export default "__VITE_ASSET__D$8c8_Pa__"